
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"250","height":"84","viewBox":"0 0 250 84","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.54211 78.5119C18.7396 83.1644 31.0389 83.3082 48.3578 76.2338C63.9978 69.8452 78.8521 56.9613 91.8564 46.7798C107.957 34.1743 142.123 16.4725 159.64 31.5869C173.241 43.3228 167.295 65.4348 146.109 67.7113C137.941 68.5888 130.876 61.2229 131.982 53.9278C133.177 46.0484 142.744 38.9797 149.605 34.7664C168.034 23.4507 187.248 34.9815 206.309 31.3012C224.118 27.8627 234.212 16.7045 243.706 3.12638C244.519 1.96332 245.813 7.26294 246.277 8.53755C247.977 13.2102 248.288 10.7489 247.003 7.21592C246.176 4.94375 245.784 -0.383653 242.758 2.17832C240.575 4.02669 235.351 6.16534 232.521 7.19462","stroke":"#07C03B","stroke-width":"2.5","stroke-linecap":"round"}})])
          )
        }
      }
    